<template>
    <li class="u-item">
        <!-- Banner -->
        <a class="u-banner" :href="postLink(item.ID)" :target="target"
            ><img :src="getBanner(item.post_banner, item.post_subtype)" :key="item.ID"
        /></a>

        <!-- 标题 -->
        <h2 class="u-post" :class="{ isSticky: item.sticky }">
            <!-- 图标 -->
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 16" width="12" height="16" aria-hidden="true" fill="#555" v-bind:class="'u-icon'" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path fill-rule="evenodd" d="M4 9H3V8h1v1zm0-3H3v1h1V6zm0-2H3v1h1V4zm0-2H3v1h1V2zm8-1v12c0 .55-.45 1-1 1H6v2l-1.5-1.5L3 16v-2H1c-.55 0-1-.45-1-1V1c0-.55.45-1 1-1h10c.55 0 1 .45 1 1zm-1 10H1v2h2v-1h3v1h5v-2zm0-10H2v9h9V1z"/></svg>

            <!-- 标题文字 -->
            <a class="u-title" :style="showHighlight(item.color)" :href="postLink(item.ID)" :target="target">{{
                item.post_title || "无标题"
            }}</a>

            <!-- 角标 -->
            <span class="u-marks" v-if="item.mark && item.mark.length">
                <i v-for="mark in item.mark" class="u-mark" :key="mark">{{ showMark(mark) }}</i>
            </span>
        </h2>

        <!-- 字段 -->
        <div class="u-content u-desc">
            {{ item.post_excerpt || item.post_title || "这个作者很懒,什么都没有留下" }}
        </div>

        <!-- 作者 -->
        <div class="u-misc">
            <img class="u-author-avatar" :src="showAvatar(item.author_info)" :alt="showNickname(item.author_info)" />
            <a class="u-author-name" :href="authorLink(item.post_author)" target="_blank">{{
                showNickname(item.author_info)
            }}</a>
            <span class="u-date">
                Updated on
                <time v-if="order == 'update'">{{ dateFormat(item.post_modified) }}</time>
                <time v-else>{{ dateFormat(item.post_date) }}</time>
            </span>
        </div>
    </li>
</template>

<script>
import { showAvatar, authorLink, showBanner, buildTarget } from "@jx3box/jx3box-common/js/utils";
import { __ossMirror, __imgPath } from "@jx3box/jx3box-common/data/jx3box";
import { cms as mark_map } from "@jx3box/jx3box-common/data/mark.json";
import { showDate } from "@jx3box/jx3box-common/js/moment.js";
export default {
    name: "ListItem",
    props: ["item", "order", "type"],
    components: {},
    data: function () {
        return {
            target: buildTarget(),
        };
    },
    computed: {},
    watch: {},
    methods: {
        getBanner: function (val, subtype) {
            if (val) {
                return showBanner(val);
            } else {
                return __imgPath + `image/banner/${this.type}` + subtype + ".png";
            }
        },
        authorLink,
        postLink: function (val) {
            return location.origin + `/${this.type}/` + val;
        },
        showHighlight: function (val) {
            return val ? `color:${val};font-weight:600;` : "";
        },
        showMark: function (val) {
            return mark_map[val] || val;
        },
        showAvatar: function (userinfo) {
            return showAvatar(userinfo?.user_avatar);
        },
        showNickname: function (userinfo) {
            return userinfo?.display_name || "匿名";
        },
        dateFormat: function (gmt) {
            return showDate(new Date(gmt));
        },
    },
    created: function () {},
    mounted: function () {},
};
</script>
